
import React, { useState } from 'react';
import { Copy, Trash2, Instagram, Facebook, Video, Mail, Package, Lightbulb, Sparkles } from 'lucide-react';


// Icon mapping by category ID
const iconMap = {
  instagram: <Instagram className="w-6 h-6" />,
  facebook: <Facebook className="w-6 h-6" />,
  tiktok: <Video className="w-6 h-6" />,
  email: <Mail className="w-6 h-6" />,
  product: <Package className="w-6 h-6" />,
  contentIdeas: <Lightbulb className="w-6 h-6" />,
  caption: <Sparkles className="w-6 h-6" />
};

// Prompt Card Component
const PromptCard = ({ prompt, onCopy, onDelete }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const maxLength = 200;
  const shouldTruncate = prompt.content.length > maxLength;
  const categoryId = prompt.categoryId || 'instagram'; // fallback to instagram if not provided
  
  return (
    <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10 hover:border-purple-500/30 transition-all duration-300 animate-fade-in">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center space-x-3">
          {iconMap[categoryId]}
          <div>
            <h3 className="font-semibold text-white">{prompt.category}</h3>
            <p className="text-xs text-gray-500">{prompt.date}</p>
          </div>
        </div>
        <div className="flex space-x-2">
          <button
            onClick={() => onCopy(prompt.content)}
            className="p-2 bg-purple-500/20 hover:bg-purple-500/30 rounded-lg transition-colors"
            title="Copier"
          >
            <Copy className="w-4 h-4 text-purple-400" />
          </button>
          <button
            onClick={() => onDelete(prompt.id)}
            className="p-2 bg-red-500/20 hover:bg-red-500/30 rounded-lg transition-colors"
            title="Supprimer"
          >
            <Trash2 className="w-4 h-4 text-red-400" />
          </button>
        </div>
      </div>
      
      <div className="bg-black/30 rounded-lg p-4 border border-white/5">
        <pre className="text-gray-300 whitespace-pre-wrap font-mono text-sm">
          {isExpanded ? prompt.content : (shouldTruncate ? prompt.content.slice(0, maxLength) + '...' : prompt.content)}
        </pre>
        {shouldTruncate && (
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="mt-2 text-purple-400 hover:text-purple-300 text-sm font-medium"
          >
            {isExpanded ? 'Voir moins' : 'Voir plus'}
          </button>
        )}
      </div>
    </div>
  );
};
export default PromptCard;